import React, { useState} from 'react';
import moment from 'moment';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { yearSelected, monthSelected, daySelected } from '../../store/actions/dateSelectorActions';
import { bindActionCreators } from 'redux';

//=================
const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  }
}));

//=================
const setDays = (props) => {
  return props.year ? Array.from(new Array(moment(props.year + "-" + props.month, "YYYY-MM").daysInMonth()), (value, counter) => {
    return counter + 1
  }) : Array.from(new Array(moment().daysInMonth()), (value, counter) => {
    return counter + 1
  });
}

//=================
const displayDays = (days) => {
  return (
    days ?
    days.map((day) =>
      <option key={ day } value={ day }>
          { day }
        </option>
    ) :
    null
  );
}

//=================
const DaySelect = (props) => {
  const [dayDisplay, setDaysDisplay] = useState(props.day)

  //---------------
  const eventHandler = (event) => {
    props.daySelected(event.target.value);
    setDaysDisplay(event.target.value);
  }

  //---------------
  return (
    <FormControl className={useStyles().formControl}>
      <Select
        native
        value={dayDisplay}
        onChange={eventHandler}
      >
      <option disabled hidden value=''>{ props.day } </option>
      { displayDays(setDays(props)) }
      </Select>
      <FormHelperText>Day</FormHelperText>
    </FormControl>
  );
};

//=================
//get reducers update value after action creator is updated
const mapStateToProps = (state) => {
  return {
    year: state.datepickerReducer.yearSelected,
    month: state.datepickerReducer.monthSelected,
    day: (state.datepickerReducer.daySelected ? state.datepickerReducer.daySelected : moment().date())
  }
}


//=================
//retrieve action creator functions
const mapDispatchToProps = dispatch => {
  return {
    daySelected: params => dispatch(daySelected(params)),
    monthSelected: params => dispatch(monthSelected(params)),
    yearSelected: params => dispatch(yearSelected(params))
  };
}

//=================
export default connect(mapStateToProps, mapDispatchToProps)(DaySelect);